import { render, staticRenderFns } from "./SeriesOptions.vue?vue&type=template&id=f63f4d1c&"
import script from "./SeriesOptions.vue?vue&type=script&lang=js&"
export * from "./SeriesOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports